import React from 'react';
import PropTypes from 'prop-types';
import Icon from './icon';

const Option = ({ value, label, iconComponent }) => (
  <div className="ws-color-scheme-select__option" key={value}>
    <Icon>{iconComponent}</Icon>
    <div className="ws-color-scheme-select__option-name">{label}</div>
  </div>
);

Option.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  iconComponent: PropTypes.node.isRequired,
};

export default Option;
